import { Grid, Typography } from '@mui/material';

export function nomineeDeclaration(): JSX.Element {
  return (
    <Grid item xs={12}>
      <Typography sx={{ textAlign: 'justify' }}>
        Since the units allotted to you are in dematerialised form, the nomination registered your
        demat account with the Depository Participant shall prevail. Please ensure that the
        nomination details with the Depository Participant are kept updated.
      </Typography>
    </Grid>
  );
}
